function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.8053 49.9994H2.40029C1.07472 49.9994 0 48.9247 0 47.5991V2.76554C0 1.43997 1.07472 0.36525 2.40029 0.36525H23.6812C24.3179 0.36525 24.9283 0.618053 25.3784 1.0682L40.5026 16.1924C40.9527 16.6426 41.2058 17.253 41.2058 17.8896V47.5991C41.2057 48.9248 40.1309 49.9994 38.8053 49.9994Z",
  fill: "#FFE49C"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.502 16.1927L25.378 1.0687C24.9279 0.618557 24.3174 0.365753 23.6808 0.365753H20.6023V49.9999H38.8048C40.1303 49.9999 41.2051 48.9252 41.2051 47.5996V17.89C41.2052 17.2535 40.9523 16.6428 40.502 16.1927Z",
  fill: "#FFD155"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7551 30.5201H15.4508C14.1253 30.5201 13.0505 29.4454 13.0505 28.1198C13.0505 26.7942 14.1253 25.7195 15.4508 25.7195H25.7551C27.0807 25.7195 28.1554 26.7942 28.1554 28.1198C28.1554 29.4454 27.0807 30.5201 25.7551 30.5201Z",
  fill: "#FFD155"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7551 38.1713H15.4508C14.1253 38.1713 13.0505 37.0966 13.0505 35.771C13.0505 34.4454 14.1253 33.3707 15.4508 33.3707H25.7551C27.0807 33.3707 28.1554 34.4454 28.1554 35.771C28.1554 37.0966 27.0807 38.1713 25.7551 38.1713Z",
  fill: "#FFD155"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7544 25.7195H20.6023V30.5202H25.7544C27.08 30.5202 28.1547 29.4455 28.1547 28.1199C28.1547 26.7944 27.08 25.7195 25.7544 25.7195Z",
  fill: "#FFBE00"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.7544 33.3702H20.6023V38.1709H25.7544C27.08 38.1709 28.1547 37.0962 28.1547 35.7706C28.1547 34.4451 27.08 33.3702 25.7544 33.3702Z",
  fill: "#FFBE00"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M40.5024 16.1945L25.3784 1.07051C25.0527 0.744697 24.6424 0.524072 24.1995 0.426071V14.9733C24.1995 16.2988 25.2742 17.3736 26.5998 17.3736H41.147C41.0488 16.9306 40.8282 16.5203 40.5024 16.1945Z",
  fill: "#FFBE00"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M36.2546 4.75378V0L44.1249 7.92297L36.2546 15.8459V11.0922C36.2546 11.0922 29.2658 9.39856 24.4918 17.4305C24.4918 17.4305 23.3015 11.3003 28.6336 6.85782C28.6336 6.85848 31.0484 4.59684 36.2546 4.75378Z",
  fill: "#15A9E1"
});

var SvgSendFile = function SvgSendFile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 50,
    viewBox: "0 0 45 50",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSendFile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send-file.2c4f5026.svg";
export { ForwardRef as ReactComponent };